define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 821
// module chunks = 2